import React from 'react';

import { TimePicker } from 'antd';

function RangeTimePicker({ value = {}, onChange }) {
  const handleChange = (name) => (event) => {
    onChange(Object.assign({}, value, { [name]: event }));
  };

  return (
    <div className="range-time-picker">
      <TimePicker
        popupClassName="range-time-picker__popup"
        value={value.begin}
        onChange={handleChange('begin')}
        placeholder=""
        format="HH:mm"
        minuteStep={10}
      />
      <div className="range-time-picker__hyphen">-</div>
      <TimePicker
        popupClassName="range-time-picker__popup"
        value={value.end}
        onChange={handleChange('end')}
        placeholder=""
        format="HH:mm"
        minuteStep={10}
      />
    </div>
  );
}

export default RangeTimePicker;
